import { render, staticRenderFns } from "./PlatformView.vue?vue&type=template&id=1add29b2"
import script from "./PlatformView.vue?vue&type=script&lang=js"
export * from "./PlatformView.vue?vue&type=script&lang=js"
import style0 from "./PlatformView.vue?vue&type=style&index=0&id=1add29b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports